const initialState_Lever = {
    request_time: null,
    error: null,
    levers: {},
};

const levers = (state = initialState_Lever, action) => {
    switch (action.type) {
        case 'SET_LEVERS':
            return {
                levers: action.payload.levers.reduce((obj, item) => {
                    obj[item.name] = item;
                    return obj;
                }, {}),
                request_time: action.request_time,
            };
        case 'SET_LEVER':
            try {
                return {
                    ...state,
                    levers: {
                        ...state.levers, [action.payload.name]: action.payload,
                    },
                    request_time: action.payload.request_time,
                };
            } catch (e) {
                console.log(e);
                return state;
            }
        case 'LEVER_ERROR':
            return {
                ...state,
                error: action.payload.error,
                request_time: null,
                // levers: {},
            };
        case "DELETE_LEVER":
            let new_levers = state.levers;
            try {
                new_levers = Object.keys(new_levers).reduce(function (filtered, key) {
                    if (new_levers[key].id !== action.payload.id) filtered[key] = new_levers[key];
                    return filtered;
                }, {});
            } catch (e) {
                console.log(e);
            }
            return {
                ...state,
                levers: new_levers,
                request_time: action.request_time,
            };
        default:
            return state;
    }
}

export default levers;